<template>
  <div class="page-content">
    <div class="inner-content">
      <div class="label main_color_text">
        Annexe
      </div>
      <sectionLexiqueCarte />
    </div>
  </div>
</template>
<script>

import sectionLexiqueCarte from "./sections/section-lexique-carte.vue";

export default {
	components: { sectionLexiqueCarte }

};
</script>
<style lang="stylus" scoped>
@import '../../../../assets/css/app';
@import '../../../../assets/css/page';
@import '../../../../assets/css/lexique';
</style>
